/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AddFamilyInformationKey, AddFamilyInformationState } from "./add-family-information-reducer";

export const selectAddFamilyInformationState = createFeatureSelector<AddFamilyInformationState>(AddFamilyInformationKey);

export const selectPdfLocationPath = createSelector(selectAddFamilyInformationState, (state) => state.pdfLocationPath);

export const selectOpenPdfFile = createSelector(selectAddFamilyInformationState, (state) => state.openPdfFile);

export const selectUserCustomImage = createSelector(selectAddFamilyInformationState, (state) => state.userCustomImage);

export const selectDeviceEquipmentInputData = createSelector(selectAddFamilyInformationState, (state) => state.deviceEquipmentInputData);